import { NgModule } from '@angular/core';

import { DisablePasteDirective } from './disable-paste.directive';

@NgModule({
  declarations: [DisablePasteDirective],
  exports: [DisablePasteDirective],
})
export class DisablePasteDirectiveModule {}
